import { Annonce } from "../types/Annonce";

export const pigeBienDetailAdapter = (
  result: Partial<Annonce> = {}
): Partial<Annonce> => result;
